export const SessionStorageKeys = {
  pagamentosFilters: 'pagamentosFilters',
  cronogramasFilters: 'cronogramasFilters',
  pagamentosPendentesFilters: 'pagamentosPendentesFilters'
}

export class SessionStorageClient {
  getItem = (key) => {
    const item = sessionStorage.getItem(key)

    return item ? JSON.parse(item) : undefined
  }

  setItem = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value))
  }

  partialUpdate = (key, value) => {
    const currentValue = this.getItem(key) ?? {}

    if (Object.keys(value).length > 0) {
      this.setItem(key, { ...currentValue, ...value })
    }
  }

  removeItem = (key) => {
    sessionStorage.removeItem(key)
  }

  clear = () => {
    sessionStorage.clear()
  }
}

export const sessionStorageClient = new SessionStorageClient()
